/**
 * TutorApplicationScreen — la candidature du tuteur, à la place de son accueil (l'onglet
 * `dashboard` du candidat, l'ancien `TutorApplicationScreen`). Un fil : le view-model, la relecture
 * et les gestes (`useTutorApplicationState`), la page du DS.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorApplicationPage } from "../../../../../../design-system/tutor"
import { tutorApplicationViewModel } from "../../../../view-models/tutor/Application/tutorApplicationViewModel"
import { useTutorApplicationState } from "./useTutorApplicationState"

export function TutorApplicationScreen() {
    const vm = useSelector(tutorApplicationViewModel)
    const gestures = useTutorApplicationState(vm)

    return (
        <TutorApplicationPage
            application={vm.application}
            loading={vm.loading}
            refreshing={vm.refreshing}
            {...gestures}
            testID="tutor-application"
        />
    )
}
